import IQueries from "@/interfaces/IQueries";

const mailSubject: IQueries = {
  mail_subjects_list: {
    path: "/vpn/mail_subjects",
    method: "GET",
  },
  mail_subject_create: {
    path: "/vpn/mail_subjects",
    method: "POST",
  },
  mail_subject_update: {
    path: "/vpn/mail_subjects/",
    method: "PUT",
  },
  mail_subject_detail: {
    path: "/vpn/mail_subjects/",
    method: "GET",
  },
};

export default mailSubject;
